// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__1H5Da","outline":"style_outline__uoVyM","noOutline":"style_noOutline__Xoz-r","btnIcon":"style_btnIcon___urqX"};